import { useKaiProApiState } from './useKaiProApiState';

/**
 * Device pixels per layout pixel: the browser's own devicePixelRatio, or what the platform reports
 * through KaiProApiStateProvider's init, defaulting to DEFAULT_DISPLAY_PIXEL_RATIO.
 */
export const useDisplayPixelRatio = (): number => useKaiProApiState().displayPixelRatio;
